import React, { useMemo } from 'react'
import T from 'prop-types'
import { styled } from '@mui/material/styles'
import { Box, Button, Card, Stack } from '@mui/material'

const classes = { sticky: 'sticky' }

export default function ConfirmBar({
  label,
  disabled,
  left,
  leftProps,
  right,
  rightProps,
  top,
  topProps,
  bottom,
  bottomProps,
  component,
  hideConfirm,
  sticky,
  handleConfirm = () => {},
}) {
  const Root = useMemo(
    () =>
      styled(component || Card)(({ theme }) => ({
        [`&.${classes.sticky}`]: {
          position: 'sticky',
          top: '68px',
          zIndex: 1,
        },
      })),
    [component]
  )

  return (
    <Root
      className={sticky ? classes.sticky : undefined}
      data-testid="confirm-bar"
    >
      {top && (
        <Box {...topProps} sx={{ p: 2, ...topProps?.sx }}>
          {top}
        </Box>
      )}
      <Stack direction="row" justifyContent="space-between" sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" {...leftProps}>
          {left}
        </Stack>
        <Stack direction="row" alignItems="center" {...rightProps}>
          {right}
          {!hideConfirm && (
            <Button
              data-testid="confirm-button"
              color="primary"
              variant="contained"
              disabled={disabled}
              onClick={handleConfirm}
              sx={{ marginLeft: (theme) => theme.spacing(2) }}
            >
              {label}
            </Button>
          )}
        </Stack>
      </Stack>
      {bottom && <Box {...bottomProps}>{bottom}</Box>}
    </Root>
  )
}

ConfirmBar.propTypes = {
  label: T.string,
  left: T.node,
  leftProps: T.object,
  right: T.node,
  rightProps: T.object,
  top: T.node,
  topProps: T.object,
  bottom: T.node,
  bottomProps: T.object,
  component: T.oneOfType([T.object, T.string]),
  disabled: T.bool,
  hideConfirm: T.bool,
  sticky: T.bool,
  handleConfirm: T.func,
}
